import { countries } from '../utilities/countries';
import { Address, AppCodeName, appSettings, emptyFields, SettlementDocumentStatus, textForSettlementDocumentStatus,
UsersType} from '../utilities/common-file';
import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../utilities/common-service';
import { ViewReceiptsService } from './view-receipts.service';
import { AuthService, encryptStorage } from '../auth/auth.service';
import { TransactionService } from '../transactions/transactions.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
 
@Component({
  selector: 'app-view-receipts',
  templateUrl: './view-receipts.component.html',
  styleUrls: ['./view-receipts.component.less']
})
export class ViewReceiptsComponent implements OnInit {
  private selectedTab = 0;
  helpDesk:any;
  companyName:any;
  address:any;
  selectedIndex = 0;
  @Input() id: any;
  @Input() type: any;
  @Input() settlementData: any;
  settlementName: string;
  countries = countries;
  merchantCurrency: any;
  emptyField = emptyFields;
  selectedResponseData: any;
  selectedDataRequest: any;
  selectedResponse: any;
  settlementStatus = SettlementDocumentStatus;
  textForDocumentStatus = textForSettlementDocumentStatus;
  userRoles = UsersType;
  merchantDetails: any;
  appCode:any;
  selectedTransaction : any;
  isLoading = true;
  constructor( private commonService: CommonService, private authService: AuthService,private transactionService: TransactionService,
               private drawerRef: NzDrawerRef, private receiptService: ViewReceiptsService) {
  }
     ngOnInit() {
      this.appCode = this.authService.getAppCode()
      this.getAddress();
      this.viewMerchantTransaction();

    }

  // To View Transaction details
  viewMerchantTransaction() {
    if (this.settlementData != undefined) {
      this.selectedTransaction = this.settlementData;
      this.isLoading = false;
    } else {
      const value = { id: this.id, merchantId: this.authService.getMerchantId() }
      this.transactionService.viewMerchantTransactionBasedOnID(value).subscribe((response: any) => {
        this.selectedTransaction = response.data.transactions[0];
        this.isLoading = false;
      }, () => {
      });
    }
  }

    tab(index: number) {
      this.selectedTab = index;
    }
    // For getting currency symbol
    getCurrency(currency) {
      return this.commonService.getCurrency(currency);
    }
    // For Getting Settlement Document Status
    getSettlementDocumentStatus(status) {
      return this.commonService.getSettlementDocumentStatus(status);
    }
    // For Settlement Document Status Tag color
    getColorForSettlementDocumentStatus(status) {
      return this.commonService.getColorForSettlementDocumentStatus(status);
    }

    // Get Frequency Status
    getFrequencyForSettlementStatus(status) {
      return this.commonService.getSettlementFrequencyStatus(status);
    }
  // To get address dynamically.
  getAddress(){
    const value ={
      name:appSettings.Address,
      appCode:this.appCode
    }
     this.transactionService.getAddress(value).subscribe((res:any)=>{
      this.address = res.data.settings[0].data.address;
      this.helpDesk = res.data.settings[0].data.helpDesk;
      this.companyName = res.data.settings[0].data.companyName;
    },err=>{
    })
  }
    // To get CreatedBy user Type
    getUserType(role) {
      return this.commonService.getUserType(role);
    }
    getMerchantName(){
      this.merchantDetails = this.authService.getMerchantDetails();
      if(this.merchantDetails && this.merchantDetails.name){
        return this.merchantDetails.name
      }
    }

    // To Close drawer
    close() {
      this.drawerRef.close();
    }
    getPdf() {
      this.receiptService.getPdfForReceipt(this.selectedTransaction.id, 'receipt');
    }
}
